import type { IconData } from '@stacksjs/iconify-core'

export const beach: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M7 38c1.368-5.675 8.458-10 17-10s15.632 4.325 17 10m-6-27c4.771 0 9 3.907 9 9m-8.86 1c2.572-2.773 2.431-7.227-.14-10m-1.61-8.352C36.228 4.286 36.638 8.162 35 11m0 0c-3.005-4.52-8.356-5.396-12-1.669\"/><path d=\"M19 28c0-9.389 7.611-17 17-17c-5.007 0-9.067 7.611-9.067 17M3 45c1.89 0 3.78-.556 5.42-1.67a2.86 2.86 0 0 1 3.16 0A9.64 9.64 0 0 0 17 45c1.89 0 3.78-.556 5.42-1.67a2.86 2.86 0 0 1 3.16 0A9.64 9.64 0 0 0 31 45c1.89 0 3.78-.556 5.42-1.67a2.86 2.86 0 0 1 3.16 0A9.64 9.64 0 0 0 45 45\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default beach
